export const CONNECTION_POINTS_LOAD = 'CONNECTION_POINTS_LOAD';
export const CONNECTION_POINTS_LOAD_SUCCESS = 'CONNECTION_POINTS_LOAD_SUCCESS';
export const CONNECTION_POINTS_LOAD_ERROR = 'CONNECTION_POINTS_LOAD_ERROR';
export const CONNECTION_POINTS_STATUSES_LOAD = 'CONNECTION_POINTS_STATUSES_LOAD';
export const CONNECTION_POINTS_STATUSES_LOAD_SUCCESS = 'CONNECTION_POINTS_STATUSES_LOAD_SUCCESS';
export const CONNECTION_POINTS_STATUSES_LOAD_ERROR = 'CONNECTION_POINTS_STATUSES_LOAD_ERROR';

export const CONNECTION_POINT_UPDATE = 'CONNECTION_POINT_UPDATE';
export const CONNECTION_POINT_UPDATE_SUCCESS = 'CONNECTION_POINT_UPDATE_SUCCESS';
export const CONNECTION_POINT_UPDATE_ERROR = 'CONNECTION_POINT_UPDATE_ERROR';

export const CONNECTION_POINT_DELETE = 'CONNECTION_POINT_DELETE';
export const CONNECTION_POINT_DELETE_SUCCESS = 'CONNECTION_POINT_DELETE_SUCCESS';
export const CONNECTION_POINT_DELETE_ERROR = 'CONNECTION_POINT_DELETE_ERROR';

export const CONNECTION_POINT_DUPLICATE = 'CONNECTION_POINT_DUPLICATE';
export const CONNECTION_POINT_DUPLICATE_SUCCESS = 'CONNECTION_POINT_DUPLICATE_SUCCESS';
export const CONNECTION_POINT_DUPLICATE_ERROR = 'CONNECTION_POINT_DUPLICATE_ERROR';

export const CONNECTION_POINT_STATUS_LOAD = 'CONNECTION_POINT_STATUS_LOAD';
export const CONNECTION_POINT_STATUS_LOAD_SUCCESS = 'CONNECTION_POINT_STATUS_LOAD_SUCCESS';
export const CONNECTION_POINT_STATUS_LOAD_ERROR = 'CONNECTION_POINT_STATUS_LOAD_ERROR';